(function () {
  'use strict';

  function initSvcSection(sectionEl) {
    var items = sectionEl.querySelectorAll('[data-svc-item]');
    var sectionSource = window.location.pathname.indexOf('/collections/') === 0
      ? 'collection_carousel'
      : 'homepage_carousel';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('[data-svc-video]');
          if (!video) return;

          if (entry.isIntersecting) {
            // Lazy-load the source only when the card is about to be seen
            var source = video.querySelector('source[data-src]');
            if (source) {
              source.src = source.getAttribute('data-src');
              source.removeAttribute('data-src');
              video.load();
            }
            var playPromise = video.play();
            if (playPromise && playPromise.catch) {
              playPromise.catch(function () {
                /* Autoplay blocked (rare on iOS if not muted) — ignore silently */
              });
            }
          } else {
            video.pause();
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.6 }
    );

    items.forEach(function (item) {
      observer.observe(item);

      var muteBtn = item.querySelector('[data-svc-mute]');
      var video = item.querySelector('[data-svc-video]');
      if (muteBtn && video) {
        var iconMuted = muteBtn.querySelector('[data-svc-icon-muted]');
        var iconUnmuted = muteBtn.querySelector('[data-svc-icon-unmuted]');

        muteBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          if (iconMuted && iconUnmuted) {
            iconMuted.style.display = video.muted ? '' : 'none';
            iconUnmuted.style.display = video.muted ? 'none' : '';
          }
        });
      }

      initQuickAdd(item);
      initVideoClickThrough(item, sectionSource);
      initForeignElementGuard(item);
    });

    initActiveCardTracking(sectionEl);
  }

  // Some storewide apps (wishlist / quick-add widgets) watch the whole page
  // for anything resembling a product card and inject their own button into
  // it — we can't always predict their class names, so instead of guessing,
  // this whitelists our OWN known elements inside the video/product areas
  // and hides anything else that shows up, on load and whenever the app
  // inserts something later.
  function initForeignElementGuard(item) {
    var guardedContainers = [
      item.querySelector('.svc-video-wrap'),
      item.querySelector('.svc-buycard')
    ].filter(Boolean);

    var allowedClasses = [
      'svc-video',
      'svc-poster-only',
      'svc-placeholder',
      'svc-mute-toggle',
      'svc-buycard-link',
      'svc-atc-btn'
    ];

    function isAllowed(el) {
      if (!el.classList) return true;
      return allowedClasses.some(function (cls) {
        return el.classList.contains(cls);
      });
    }

    function sweep(container) {
      Array.prototype.forEach.call(container.children, function (child) {
        if (!isAllowed(child)) {
          child.style.setProperty('display', 'none', 'important');
        }
      });
    }

    guardedContainers.forEach(function (container) {
      sweep(container);
      var mo = new MutationObserver(function () {
        sweep(container);
      });
      mo.observe(container, { childList: true });
    });
  }

  // Tapping the video itself (not the mute button, not the product
  // card / add-to-cart controls) takes the customer to the product page.
  function initVideoClickThrough(item, sectionSource) {
    var videoWrap = item.querySelector('.svc-video-wrap');
    var productUrl = item.getAttribute('data-product-url');
    if (!videoWrap || !productUrl) return;

    var productId = item.getAttribute('data-product-id') || '';

    videoWrap.style.cursor = 'pointer';
    videoWrap.addEventListener('click', function () {
      trackVideoCarouselClick(sectionSource, productId);
      // Small delay so the analytics beacon has a moment to actually send
      // before the page starts navigating away.
      setTimeout(function () {
        window.location.href = productUrl;
      }, 120);
    });
  }

  // Pushes a click event to dataLayer (works with GA4/GTM) and fires a
  // Meta Pixel custom event if it's present — both are no-ops if that
  // particular tool isn't installed on the site, so this is safe either way.
  function trackVideoCarouselClick(source, productId) {
    // Primary path: call gtag() directly. This is what actually creates a
    // GA4 event — a bare dataLayer.push only becomes a GA4 hit if a GTM
    // Custom Event trigger is configured for this exact event name, which
    // isn't set up here, so gtag() is what makes this reliably show up.
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'video_carousel_click', {
          video_source: source,
          product_id: productId
        });
      }
    } catch (e) {
      /* gtag unavailable — ignore */
    }

    // Kept as a fallback so the event is still visible in dataLayer /
    // GTM's preview mode if a Custom Event trigger is ever added there.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_carousel_click',
        video_source: source,
        product_id: productId
      });
    } catch (e) {
      /* dataLayer unavailable — ignore */
    }

    try {
      if (typeof fbq === 'function') {
        fbq('trackCustom', 'VideoCarouselClick', {
          source: source,
          product_id: productId
        });
      }
    } catch (e) {
      /* Meta Pixel unavailable — ignore */
    }
  }

  // Scales up / brings forward whichever card is nearest the carousel's
  // center, so it reads as "in front" of its neighbors — like the reference
  // Whatmore-style carousel. Runs on scroll (rAF-throttled) and on load/resize.
  function initActiveCardTracking(sectionEl) {
    var carousel = sectionEl.querySelector('.svc-carousel');
    var items = sectionEl.querySelectorAll('[data-svc-item]');
    if (!carousel || !items.length) return;

    var ticking = false;

    function updateActiveItem() {
      var carouselRect = carousel.getBoundingClientRect();
      var carouselCenter = carouselRect.left + carouselRect.width / 2;
      var closest = null;
      var closestDist = Infinity;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var dist = Math.abs(itemCenter - carouselCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = item;
        }
      });

      items.forEach(function (item) {
        item.classList.toggle('is-active', item === closest);
      });

      ticking = false;
    }

    carousel.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateActiveItem);
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', updateActiveItem);

    // Set the initial active card once layout has settled
    window.requestAnimationFrame(updateActiveItem);
  }

  function initQuickAdd(item) {
    var atcBtn = item.querySelector('[data-svc-atc]');
    var picker = item.querySelector('[data-svc-size-picker]');
    if (!atcBtn || !picker) return;

    var closeBtn = picker.querySelector('[data-svc-size-close]');
    var status = picker.querySelector('[data-svc-atc-status]');
    var pills = picker.querySelectorAll('[data-svc-size-pill]');

    function openPicker(e) {
      e.preventDefault();
      e.stopPropagation();
      picker.hidden = false;
    }

    function closePicker(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      picker.hidden = true;
    }

    atcBtn.addEventListener('click', openPicker);
    if (closeBtn) closeBtn.addEventListener('click', closePicker);

    // Tapping the dark backdrop (but not the sheet itself) closes it
    picker.addEventListener('click', function (e) {
      if (e.target === picker) closePicker(e);
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (pill.disabled) return;

        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');

        var variantId = pill.getAttribute('data-variant-id');
        if (!variantId) return;

        addToCart(variantId, status, closePicker);
      });
    });
  }

  function addToCart(variantId, statusEl, onDone) {
    if (statusEl) statusEl.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        if (statusEl) statusEl.textContent = 'Added to cart ✓';
        refreshCartUI();
        setTimeout(function () {
          if (onDone) onDone();
        }, 700);
      })
      .catch(function (err) {
        if (statusEl) statusEl.textContent = err.message || 'Something went wrong';
      });
  }

  // Best-effort refresh of Dawn's cart icon bubble / cart drawer, if present.
  // Falls back to silently doing nothing if the theme's markup differs —
  // the item is already in the cart either way via /cart/add.js above.
  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    fetch('/cart?sections=cart-icon-bubble,cart-drawer')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (sections) {
        if (!sections) return;

        Object.keys(sections).forEach(function (key) {
          var target = document.getElementById(key);
          if (!target) return;
          var html = new DOMParser().parseFromString(sections[key], 'text/html');
          var newEl = html.getElementById(key);
          if (newEl) target.innerHTML = newEl.innerHTML;
        });

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .catch(function () {
        /* Theme's cart markup may differ — the add itself already succeeded */
      });
  }

  function initAll() {
    document.querySelectorAll('.svc-section').forEach(initSvcSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/edited live in the theme customizer
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.svc-section');
    if (section) initSvcSection(section);
  });
})();